(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-payload-handler/assets/javascripts/intersection-observer.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-payload-handler/assets/javascripts/intersection-observer.js'); "use strict";

const logger = svs.core.log.getLogger('components:adobe-target-payload-handler');
const visualElements = new Set();
const elementSent = new Set();
let intersectionObserver;
const intersectionObserverOptions = {
  root: null,
  rootMargin: '0px',
  threshold: [0.4, 0.5]
}; 

const dataAttributes = ['[data-crm-mbox]'];
const TIME_TO_IMPRESSION = 500;

function timeInViewport(element) {
  const {
    sendView,
    setupClickInMbox
  } = svs.components.adobeTargetPayloadHandler;
  return setTimeout(() => {
    if (visualElements.has(element) && !elementSent.has(element)) {
      sendView(element);
      setupClickInMbox(element);
      elementSent.add(element);
      visualElements.delete(element);
    }
  }, TIME_TO_IMPRESSION);
}

function handleIntersection(entries) {
  entries.forEach(entry => {
    const el = entry.target;

    if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
      visualElements.add(el);
      timeInViewport(el);
    } else {
      visualElements.delete(el);
    }
  });
}

function setupImpressionTracking() {
  if ('IntersectionObserver' in window) {
    intersectionObserver = new IntersectionObserver(handleIntersection, intersectionObserverOptions);

    try {
      const elementsToTrack = document.querySelectorAll(dataAttributes.join(','));

      for (let i = 0; i < elementsToTrack.length; i++) {
        intersectionObserver.observe(elementsToTrack[i]);
      } 

    } catch (e) {
      logger.warn("Unexpected error:".concat(e.message));
    }
  } else {
  }
} 


$(() => {
  setupImpressionTracking();
}); 

$(window).on('unload', () => {
  $(window).off('load', setupImpressionTracking);
});
 })(window);